module.exports = __webpack_public_path__ + "fonts/icomoon.619dc501.eot";